import React from 'react';
import IForm from '../../../types/IForm';
import { Heading } from '../../../_lib/components/Heading/Heading';

import { PostsEditorWithUpload } from '../../../_lib/components/Posts';
import { useAppContext } from '../../../contexts/AppContext/AppContext';

type ThreadBlockMainEditor = {
  hierarchy: number;
  headline: string;
  createForm?: IForm;
};

/**
 * Main Editor for Threads which creates new Posts.
 * Located at the bottom of a thread and will not be shown when page is in editmode.
 */
export function ThreadBlockMainEditor({ createForm, hierarchy, headline }: ThreadBlockMainEditor) {
  const { editModeInfo } = useAppContext();

  if (!createForm || editModeInfo.active) {
    return null;
  }

  return (
    <div className="thread__main-editor" id="threads-main-editor">
      <Heading hierarchy={hierarchy} className="posts__heading">
        {headline}
      </Heading>
      <div id="thread-main-editor">
        <PostsEditorWithUpload form={createForm} type="thread" />
      </div>
    </div>
  );
}
